/*
 * Copyright (c) 2022 by 安徽网才信息技术股份有限公司
 *
 * 除非事先获得版权所有人的许可, 禁止以下几项行为:
 * 1. 对该软件的任何源代码和技术文档进行任意形式的打包、分发或复制用于其他目的。
 * 2. 向第三方透露任何与该软件相关的源代码或技术文档。
 * 3. 更改或删除软件或源码中的版权声明。
 *
 */
import api from '@/utils/api.request';

// 获取配置信息
export const getMeta = () => {
    return api.request({
        url: 'frontend/meta',
        method: 'get'
    });
};

// 是否启用强制关注
export const getWeChatForceSubscribe = () => {
    return api.request({
        url: 'frontend/wechat/force/subscribe',
        method: 'get'
    });
};

// 附件上传
export const uploadFile = (data) => {
    return api.request({
        url: '/frontend/upload',
        data,
        method: 'post'
    });
};

export const printForm = (content) => {
    const newTab = window.open('about:blank', '_blank');
    newTab.document.body.innerHTML = content;
    setTimeout(function(){
        newTab.print();
    }, 1200);
};

// 保存反馈信息
export const saveFeedback = (data) => {
    return api.request({
        url: '/frontend/feedback',
        data,
        method: 'post'
    });
};

// 获取反馈列表
export const feedbackList = (param) => {
    return api.request({
        url: '/frontend/feedback/list',
        method: 'get',
        params: param
    });
};

// 获取反馈详情
export const getFeedback = (param) => {
    return api.request({
        url: 'frontend/feedback/info',
        method: 'get',
        params: param
    });
};
